/**
 * Fomantic visual set — 148 outline-stroke SVGs using Fomantic UI's
 * canonical name vocabulary. Default ry-ui look.
 *
 * Side-effect import: pulling this module in registers every glyph under
 * the `fomantic` set. ry-ui's main entry already imports it, so consumers
 * using `<ry-icon name="…">` get this set by default with no extra setup.
 */
import { registerSet } from '../core/ry-icons.js';
import { ICONS } from './_data.js';

registerSet('fomantic', ICONS);
